import { useEffect, useState } from 'react';
import { RedocStandalone } from 'redoc';
import { theme } from 'redark-theme';
import styles from './ApiDocs.module.css';
import { Search, Copy, CheckCircle } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import CodeBlock from '@/components/ui/code-block';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const SWAGGER_URL = import.meta.env.VITE_API_URL.slice(0, -4) + '/swagger/v1/swagger.json';

const PublicApiDocs = () => {
  
  
  return (
    <div className="h-screen bg-background overflow-hidden">
      {/* Main content area */}
      <div className="flex flex-col h-full w-full max-w-full mx-auto px-3 sm:px-4 lg:px-6 py-4 pt-6">
        {/* RecallIO Logo */}
        <div className="flex justify-center mb-6">
          <a href="https://recallio.ai" target="_blank" rel="noopener noreferrer">
            <img 
              src="/lovable-uploads/4eecbb54-a517-42eb-bf2a-f06ad5d82aee.png" 
              alt="RecallIO Logo" 
              className="h-12 w-auto"
            />
          </a>
        </div>
        
        {/* Page title and description */}
        {/* <div className="mb-6">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold break-words">API Documentation</h1>
          <p className="text-muted-foreground mt-2 break-words text-sm sm:text-base">
            Complete reference for the Recallio Compliance-First Memory API
          </p>
        </div> */}
        
        {/* Main content */}
        <div className="w-full flex-1 min-h-0">
          <div className={`w-full ${styles.apiDocsContainer}`}>
            <Card className="mb-6 h-full flex flex-col">
              <CardHeader>
                <CardTitle>📚 Explore Examples & SDKs</CardTitle>
                <CardDescription>
                  Check out our GitHub repository for complete Node.js and Python SDK examples, integration guides, and best practices.<br/>
                  Explore all endpoints, request/response schemas, and authentication methods or use the <b><u><a href="https://app.recallio.ai/swagger" target="_blank">Swagger UI</a></u></b> to test your requests.
                </CardDescription>
              </CardHeader>
              <CardContent className="p-0 flex-1 min-h-0">
                <div className="flex justify-start gap-2">
                  <Button variant="outline" asChild style={{backgroundColor: '#83ffd5', color: 'black'}}>
                    <a href="https://github.com/RecallIO/recallio" target="_blank">
                      <span>View on GitHub</span>
                    </a>
                  </Button>
                  <Button variant="outline" asChild style={{backgroundColor: '#83ffd5', color: 'black'}}>
                    <a href="https://app.recallio.ai/swagger" target="_blank">
                      <span>Swagger UI</span>
                    </a>
                  </Button>
                </div>
                <div className={`w-full h-full ${styles.redocContainer}`}>
                  <RedocStandalone 
                    specUrl={SWAGGER_URL}
                    options={{
                      theme: theme,
                      //scrollYOffset: 60,
                      hideDownloadButton: false,
                      disableSearch: false,
                      hideHostname: false,
                      expandResponses: '200,201',
                      requiredPropsFirst: true,
                      sortPropsAlphabetically: true,
                      showExtensions: true,
                      pathInMiddlePanel: true,
                      menuToggle: true
                    }}
                  />
                </div>
              </CardContent>
            </Card>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicApiDocs; 